var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarharttchanneltalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1179_12358)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 0H24.6C11.0138 0 0 11.0138 0 24.6V31.4C0 44.9862 11.0138 56 24.6 56H31.4C44.9862 56 56 44.9862 56 31.4V24.6C56 11.0138 44.9862 0 31.4 0Z",
    fill: "#4657A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1179_12358",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 30,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4098 10.1914H11.5898V43.8114H40.4098V10.1914Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1179_12358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8816 25.8819C30.1816 25.8819 28.6716 22.3219 28.6716 19.8919C28.6716 15.5319 31.9116 13.4719 34.2516 13.4719C36.5916 13.4719 37.4516 14.5619 37.4516 14.5619C37.3316 14.5119 36.9916 14.4119 36.5816 14.4119C33.7616 14.4119 33.0416 16.8819 33.0416 18.1219C33.0416 19.7319 34.1716 21.6519 36.5816 21.6519C39.4216 21.6519 40.0816 19.1319 40.0816 17.9419C40.0816 14.4519 36.6816 10.1719 28.2516 10.1719C19.4016 10.1719 11.6016 18.1619 11.6016 27.0319C11.6016 39.9419 21.8216 43.8019 27.7816 43.8019H40.4216V21.9219C39.5516 24.2919 37.5716 25.8819 34.8916 25.8819H34.8816Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1179_12358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarharttchanneltalk);
export default __webpack_public_path__ + "static/media/icon-carharttchanneltalk.461467e860fd18230e7c8c2b43ccd744.svg";
export { ForwardRef as ReactComponent };